import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("b", null, " Download ", -1);
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
import { computed } from 'vue';
import { useStore } from 'vuex';
import formatDateTime from '@utils/format-date-time';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReportStatusDropdownItem',
    props: {
        report: { default: () => ({
                status: { text: '', value: '' },
            }) }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const cancelableStatus = computed(() => ['pending', 'in_progress'].includes(props.report.status.value));
        function cancelReport() {
            if (cancelableStatus.value) {
                void store.dispatch('reports/cancelReportFileGeneration', props.report.id);
            }
        }
        function checkIfPDF() {
            const downloadType = props.report.name?.endsWith('.pdf') ? 'pdfReports' : undefined;
            void store.dispatch('reports/downloadReport', {
                link: props.report.file,
                type: downloadType,
            });
        }
        function formatReportExpiry(expiry) {
            return expiry ? formatDateTime(expiry) : '';
        }
        return (_ctx, _cache) => {
            const _component_BaseIcon = _resolveComponent("BaseIcon");
            const _component_b_row = _resolveComponent("b-row");
            const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
            const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_b_dropdown_item, { href: "#" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_b_row, { class: "d-flex justify-content-between" }, {
                            default: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString(_ctx.report.name), 1),
                                (_ctx.report.status.value === 'ready')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "download",
                                        "data-test": "download-report",
                                        onClick: checkIfPDF
                                    }, [
                                        _createVNode(_component_BaseIcon, { name: "download" }),
                                        _hoisted_1
                                    ]))
                                    : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 1
                        }),
                        _createVNode(_component_b_row, {
                            "data-test": "report-status-action",
                            class: _normalizeClass(_ctx.report.status.value === 'failed' ? 'red-text d-flex' : 'd-flex justify-content-between'),
                            onClick: _cache[0] || (_cache[0] = ($event) => (cancelReport()))
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.report.status.text), 1),
                                (_ctx.report.status.value === 'failed')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(_ctx.report.error_message) + ") ", 1))
                                    : _createCommentVNode("", true),
                                (_ctx.report.status.value === 'ready')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Expires on: " + _toDisplayString(formatReportExpiry(_ctx.report.expired_at)), 1))
                                    : _createCommentVNode("", true),
                                (cancelableStatus.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Cancel "))
                                    : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 1
                        }, 8, ["class"])
                    ], undefined, true),
                    _: 1
                }),
                _createVNode(_component_b_dropdown_divider)
            ]));
        };
    }
});
